import { render, staticRenderFns } from "./pogs-form__item--admission.vue?vue&type=template&id=175b0e77&scoped=true&"
import script from "./pogs-form__item--admission.vue?vue&type=script&lang=js&"
export * from "./pogs-form__item--admission.vue?vue&type=script&lang=js&"
import style0 from "./pogs-form__item--admission.vue?vue&type=style&index=0&id=175b0e77&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175b0e77",
  null
  
)

export default component.exports